<template lang="pug">
  v-row(no-gutters)
    v-col(cols=12 md=6)
      v-sheet(color="transparent").enrollment-sheet.pl-4.relative
        //- v-alert(
        //-   v-if=`
        //-     !users.items.length
        //-     && !loading.users
        //-     && !users.q
        //-     && !users.searchKeys
        //-     && !enrollMode`
        //-   type="info"
        //-   text
        //-   prominent
        //-   color="secondary"
        //- ).ma-4
        //-   v-row(align="center")
        //-     v-col.grow Ни одного пользователя нет в наборе
        //-     v-col.shrink
        //-       v-btn(
        //-         v-if="course.type === $conf.COURSE_TYPES.qualification"
        //-         outlined
        //-         rounded
        //-         color="secondary"
        //-         :to=`{
        //-           name: 'CourseRegistrationStaff',
        //-           params: {
        //-             courseId: course.id,
        //-             enrollmentId: enrollment.id,
        //-           }
        //-         }`
        //-       ) Перейти к записи
        v-list(
          color="transparent"
        )
          v-subheader.d-flex.align-center
            .text-uppercase Пользователи из набора
            v-spacer
            v-switch(
              v-model="enrollMode"
              color="secondary"
              rounded
              text
              inset
              label="Режим зачисления"
              outlined
              hide-details
              @click="users.selected = []"
            ).pt-0.mt-0
          v-list-item.mb-2.px-0
            v-list-item-content
              v-text-field(
                v-model="users.q"
                label="ФИО"
                hide-details
                rounded
                filled
                clearable
                outlined
              )
              v-chip-group(
                v-model="searchStatus"
                mandatory
                column
              )
                v-chip(
                  small
                  filter
                  :value="null"
                  color="secondary"
                ) Все
                v-chip(
                  small
                  filter
                  :value="$conf.ATTESTATION_STATUSES.enrolled"
                  color="secondary"
                ) Зачислен
                v-chip(
                  small
                  filter
                  :value="$conf.ATTESTATION_STATUSES.excluded"
                  color="secondary"
                ) Отклоненные
                v-chip(
                  small
                  filter
                  :value="10"
                  color="secondary"
                ) Заявка
            v-list-item-action
              v-badge(
                :value="hasFilters"
                dot
                overlap
                left
                offset-x="15"
                offset-y="15"
                color="secondary"
              )
                v-btn(
                  fab
                  text
                  @click="setFilters"
                )
                  v-icon mdi-tune

          v-list-item(v-if="!loading.users && !users.items.length")
            v-list-item-content
              v-list-item-subtitle Пользователи не найдены...
          v-fade-transition(leave-absolute)
            v-skeleton-loader(
              v-if="loading.users"
              type="list-item-two-line@5"
            )
          lazy-load(
            v-if="!loading.users"
            v-model="users.loadMore"
            @on-response="({ items, pagination }) => onResponse(items, pagination)"
          )
            v-list-item-group(
              v-model="users.selected"
              :multiple="enrollMode"
            )
              v-list-item(
                v-for="user in users.items"
                :key="user.id"
                :value="user"
              ).mb-1
                template(#default="{ active }")
                  v-list-item-avatar
                    v-checkbox(
                      v-if="enrollMode"
                      color="secondary"
                      :input-value="active"
                    )
                    v-avatar(v-else
                      :color="user.statusEnrollmentColor + ' lighten-4'"
                    )
                      v-icon(
                        :color="user.statusEnrollmentColor"
                      ) mdi-account
                  v-list-item-content
                    v-list-item-title {{ user.full_name }}
                    v-list-item-subtitle(
                      v-if="user.record.group"
                    ) {{ user.record.group.short_name }}
                    v-list-item-subtitle(
                      v-else-if="user.record.status === $conf.ATTESTATION_STATUSES.excluded"
                    ) Заявка отклонена
                    v-list-item-subtitle(v-else) Не зачислен
                  v-list-item-action
                    v-tooltip(top)
                      template(#activator="{ on }")
                        v-chip.pr-0(
                          v-on="on" x-small :color="user.isValidAttrs ? 'success' : 'warning'"
                        )
                          v-chip(
                            v-if="user.statements.length > 1 || user.scanRequired"
                            small :color="user.isValidState ? 'success' : 'warning'"
                            ).pl-0
                      span {{user.isValidAttrs ? 'Все данные заполнены' : 'Данные не заполнены'}}
                      div(
                        v-if="user.statements.length > 1 || user.scanRequired"
                      ) {{ user.isValidState ? 'Все файлы загружены' : 'Файл(ы) не загружены'}}
                    div
                      span.text-caption.mr-1 ₽
                      v-chip.px-1(
                        x-small
                        :color="user.payment_percent > 50 ? 'success': 'error'"
                      )  {{ user.payment_percent }}%
        v-row.ma-0.mb-2.mt-2(
          style="position:sticky; bottom: 8px; right: 0;"
        )
          v-spacer
          v-chip(small color="primary") Всего: {{ pagination.total }}
    v-col(
      v-if="enrollMode"
      cols=12 md=6
    )
      v-sheet(color="grey lighten-5").fill-height.pa-4.d-flex.align-center
        v-row
          v-col
            .text-center
              .text-h5.mb-3
                span Зачисление
              span Выбрано всего
                strong  {{ users.selected.length }}
            .d-flex.justify-center
              v-sheet(max-width="400").d-flex.my-8
                v-select(
                  v-model="groups.selected"
                  :items="course.groups"
                  label="Выберите группу"
                  item-text="short_name"
                  rounded
                  filled
                  hide-details
                  return-object
                )
                v-btn(
                  :to="{ name: 'GroupCreate', params: { enrollmentId: enrollment.id }}"
                  light
                  depressed
                  fab
                  rounded
                ).ml-2
                  v-icon mdi-plus
            .text-center
              v-btn(
                color="success"
                :disabled="!groups.selected || !users.selected.length"
                :loading="loading.addUsers"
                rounded
                depressed
                x-large
                @click="addUsersToGroup"
              )
                span Зачислить выбранных пользователей
                v-icon(right) mdi-check
              template(v-if="course.type === $conf.COURSE_TYPES.general")
                v-btn(
                  :disabled="!isPfdoGroupCreateAvailable"
                  :loading="loading.createPfdoGroups"
                  rounded filled
                  text
                  block
                  x-large
                  depressed
                  @click="createPFDOGroups"
                ).mt-5 Сформировать группы как на ПФДО
    v-col(
      v-else
      cols=12 md=6
    )
      v-sheet(color="grey lighten-5").enrollment-sheet.grey.lighten-5
        .d-flex.justify-center.align-center.fill-height(
          v-if="!studentOpened"
        )
          v-sheet(color="transparent" max-width=200).text-center
            v-icon(
              size=100
              color="secondary"
            ) mdi-account
            .caption Для зачисления выберите пользователя из списка
        enrollment-element-user.pa-3(
          v-else
          :key="users.selected.id"
          :course="course"
          :user="users.selected"
          :enrollment="enrollment"
          :groups="course.groups"
          @update:user="updateUser"
          @update:attribute="updateAttribute"
          @update:statement="updateStatement"
        )
</template>

<script>
import EnrollmentElementFilters from '@/modules/CourseManagement/components/Enrollment/EnrollmentElementFilters.vue';
import EnrollmentElementUser from '@/modules/CourseManagement/components/Enrollment//EnrollmentElementUser.vue';

export default {
  components: {
    EnrollmentElementFilters,
    EnrollmentElementUser,
  },
  props: {
    enrollment: { type: Object, required: true },
    course: { type: Object, required: true },
  },
  data() {
    return {
      searchStatus: null,
      pagination: {},
      mode: null,

      users: {
        q: null,
        searchKeys: null,

        items: [],
        loadMore: null,
        selected: [],
      },
      groups: {
        seleted: null,
      },
      enrollMode: false,

      isPfdoGroupCreateAvailable: false,
      loading: {
        users: true,
        addUsers: false,
        createPfdoGroups: false,
        loadMore: false,
      },

      SHEET_HEIGHTS: 600,
    };
  },
  computed: {
    waitForEnrollUsers() {
      return this.users.items.filter((user) => !user.record.group);
    },
    hasFilters() {
      if (!this.users.searchKeys) return false;
      return !!Object.values(this.users.searchKeys).find((v) => v);
    },
    studentOpened() {
      return this.users.selected && !Array.isArray(this.users.selected);
    },
    queryFilterParams() {
      return {
        expand: 'attributes,statements,payment_percent',
        'search[full_name]': this.users.q,
        ...this.searchStatus === 10 ? { 'search[status_null]': 1 } : { 'search[status]': this.searchStatus },
        ...this.enrollMode ? { 'search[group_exists]': 0 } : {},
        ...this.users.searchKeys,
      };
    },
  },
  watch: {
    waitForEnrollUsers(val) {
      this.$emit('update:waitForEnrollUsers', val.length);
      this.$emit('update:recorded', this.users.items.length - val.length);
    },
    queryFilterParams() {
      this.fetchUsers();
    },
  },
  created() {
    this.fetchUsers();
  },
  methods: {
    onResponse(items, pagination) {
      this.pagination = pagination;

      this.users.items.push(
        ...items.map((i) => {
          i.setupAttributes(this.enrollment.attributes);
          return i;
        }),
      );
    },
    async fetchUsers() {
      this.loading.users = true;
      const modelParams = {
        is_enrollment_scan_required: this.enrollment.is_enrollment_scan_required,
      };
      const { items, loadMore, pagination } = await this.$api.enrollments.enrollmentUsers(
        this.enrollment.id, this.queryFilterParams, modelParams,
      );
      this.pagination = pagination;
      this.users.items = items;
      this.users.items.forEach((i) => i.setupAttributes(this.enrollment.attributes));
      this.users.loadMore = loadMore;
      // TODO: Reseach - what is this?
      // this.isPfdoGroupCreateAvailable = resp.data.data.isCreateGroupFromPfdoGroup;
      this.loading.users = false;
    },
    async addUsersToGroup() {
      this.loading.addUsers = true;

      const { excluded, enrolled } = this.$conf.ATTESTATION_STATUSES;
      const conclusion = (record) => record.status === excluded
        && this.groups.selected.id === record.group.id;
      const records = this.users.selected.map((u) => ({
        prior_record_user_id: u.id,
        ...conclusion(u.record) ? {} : { group_id: this.groups.selected.id },
        status: enrolled,
      }));
      await this.$api.enrollments.changeStatusMass(records);
      this.$toasted.success('Пользователи успешно добавлены');
      this.users.selected = [];
      this.enrollMode = false;
      this.loading.addUsers = false;
    },
    createPFDOGroups() {
      this.loading.createPfdoGroups = true;
      this.$api.groups.createPFDOGroups(this.course.id);
      this.$toasted.success('Группы успешно добавлены');
      this.loading.createPfdoGroups = false;
    },
    updateUser({ user, key, value }) {
      this.$set(user, key, value);
    },
    updateAttribute({ attr, value }) {
      this.$set(attr, 'value', value);
    },
    updateStatement({ statement, value }) {
      this.$set(statement, 'user_file', value);
    },
    setFilters() {
      this.$modals.show('confirm-controller', {
        title: 'Фильтрация пользователей',
        message: null,
        icon: 'mdi-tune',
        method: (data) => { this.users.searchKeys = data; },
        component: EnrollmentElementFilters,
        componentInitialData: this.users.searchKeys,
        'component-props': {
          courseType: this.course.type,
          courseId: this.course.id,
          groups: this.course.groups,
        },
      });
    },
  },
};
</script>
